export const ShareWithUrl = async () => {
	const currentUrl = window.location.href

	if (navigator.share) {
		try {
			await navigator.share({
				title: document.title,
				text: 'Mira este producto que encontré',
				url: currentUrl,
			})
			console.log('Compartido con éxito')
		} catch (err) {
			console.error('Error al compartir:', err)
		}
	} else {
		try {
			await navigator.clipboard.writeText(currentUrl)
			alert('Enlace copiado al portapapeles')
		} catch (err) {
			console.error('Error al copiar:', err)
		}
	}
}
